import React from 'react';
import AudienceForm from './audiences/AudienceForm';
import MainContent from './layout/MainContent';

const AudienceNew = () => {
    //Nodos
    const nodes = [];
    //Acciones
    const actions = [];
    //Renderizo
    return (
        <MainContent 
            title='Audiencias' 
            subtitle='Audiencias' 
            nodes={nodes}
            actions={actions}
            component={AudienceForm} />
    );
};

export default AudienceNew;